/*global jQuery*/
(function ($) {
    'use strict';

    /**
     * Слайдер на главной странице
     *
     * @param {object} [options] - объект с настройками слайдера
     * @param {number} options.autoswitch - Интервал автоматического переключения слайдов (мс)
     *
     * @returns {jQuery}
     */
    $.fn.indexSlider = function (options) {
        var defaults = {
            autoswitch: 5000
        };
        var settings = $.extend({}, defaults, options);

        var $self = $(this);
        var $mainItems = $self.find('.js-index-slider-main-item');
        var $listItems = $self.find('.js-index-slider-list-item');
        var $arrPrev = $self.find('.js-index-slider-prev');
        var $arrNext = $self.find('.js-index-slider-next');
        var autoswitchInterval;

        /**
         * возвращает функцию для анимации
         * @param index
         * @return {(function(*): void)|*}
         */
        var getAnimationCircleProgressFn = function (index) {
            var $circle = $listItems.eq(index).find('.js-index-slider-list-circle-progress');
            var circuit = $circle.attr('stroke-dasharray');
            var start = null;

            return function (timestamp) {
                if (!start) {
                    start = timestamp;
                }

                var elapsed = timestamp - start;

                $circle.css({
                   strokeDashoffset: circuit - ((circuit / settings.autoswitch) * elapsed),
                });

                if (elapsed > settings.autoswitch) {
                    $circle.css({
                        strokeDashofsset: circuit,
                    });
                    return;
                }
                window.requestAnimationFrame(progressAnimationFn);
            }
        }

        var progressAnimationFn = null;

        /**
         * Перейти к слайду с указанным индексом
         * @param index
         */
        var goToSlide = function(index) {
            $mainItems.removeClass('active').eq(index).addClass('active');
            $listItems.removeClass('active').eq(index).addClass('active');

            progressAnimationFn = getAnimationCircleProgressFn(index);

            window.requestAnimationFrame(progressAnimationFn);

            if (settings.autoswitch) {
                clearInterval(autoswitchInterval);
                autoswitchInterval = setInterval(nextSlide, settings.autoswitch);
            }
        };

        /**
         * Перейти к предыдущему слайду
         */
        var prevSlide = function () {
            var currentIndex = $mainItems.filter('.active').index();
            goToSlide((currentIndex + $mainItems.length - 1) % $mainItems.length);
        };

        /**
         * Перейти к предыдущему слайду
         */
        var nextSlide = function () {
            var currentIndex = $mainItems.filter('.active').index();
            goToSlide((currentIndex + 1) % $mainItems.length);
        };

        /**
         * Инициализация
         */
        var init = function () {
            goToSlide(0);

            $arrPrev.on('click', prevSlide);
            $arrNext.on('click', nextSlide);
            $listItems.on('click', function () {
                goToSlide($(this).index());
            });
        };

        init();

        /**
         * Публичные методы
         */
        this.goToSlide = goToSlide;
        this.prevSlide = prevSlide;
        this.nextSlide = nextSlide;

        return this;
    };

})(jQuery);
